// Shared SWR cache key for the email-templates list. Kept in one place so the
// list route and the detail editor (which invalidates the list after deleting a
// template) agree on the exact key.
export const EMAIL_TEMPLATES_KEY = ['admin/email-templates'] as const;
